import { Box, Grid, HiddenProps, styled, styledComponent, Typography } from '@hermes/web-components'

const borderStyle = '1px solid #BFCDF6'

export const TabsRoot = styled('div')`
  display: flex;
`

export const SearchResultsModalRoot = styled('div')`
  background-color: white;
  border: 1px solid #bfcdf6;
  border-radius: 16px;
  display: block;
  filter: drop-shadow(0px 3px 4px rgba(2, 3, 3, 0.03)) drop-shadow(0px 3px 3px rgba(2, 3, 3, 0.02))
    drop-shadow(0px 1px 8px rgba(2, 3, 3, 0.04));
  font-family: Poppins;
  min-width: 432px;
  position: absolute;
  @media (max-width: 760px) {
    filter: none;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 60px 20px 0 20px;
    box-sizing: border-box;
    overflow-y: auto;
    z-index: 999;
  }
`

export const SearchResultsMobileTitle = {
  fontSize: '16.88px',
  fontWeight: 400,
  marginBottom: '8px',
  lineHeight: '25px',
  color: '#313743'
}

export const HideMobile = styled('div')`
  @media (max-width: 760px) {
    display: none;
  }
`

export const HideDesktop = styled('div')`
  @media (min-width: 760px) {
    display: none;
  }
`

export const RootContainer = styled('div', {
  shouldForwardProp: (prop: string) => !['specialistOrPractice'].includes(prop)
})<{ specialistOrPractice?: boolean }>(({ theme, specialistOrPractice }) => ({
  boxSizing: 'border-box',
  height: '361px',
  overflowY: 'auto',
  padding: '0 16px',
  width: '100%',
  borderRight: !specialistOrPractice ? borderStyle : '',
  [theme.breakpoints.down('lg')]: {
    height: 'initial',
    overflowY: 'hidden'
  }
}))

export const ItemRootContainer = styledComponent(Box)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1.5, 2),
  margin: theme.spacing(0, 3),
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  minHeight: 47,
  borderBottom: borderStyle,
  '&:hover': {
    cursor: 'pointer',
    userSelect: 'none',
    backgroundColor: '#F4F7FD'
  }
}))

export const ItemLogo = styled('img')`
  border-radius: 50%;
  height: 48px;
  margin-right: 16px;
  width: 48px;
`
export const ItemTitleContainer = styled('div')`
  display: flex;
  flex-direction: column;
`

export const ItemSubTitle = styledComponent(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.text.disabled
}))

export const ItemTitle = styledComponent(Typography, {
  shouldForwardProp: (prop: string) => !['specialistOrPractice'].includes(prop)
})<{ specialistOrPractice?: boolean }>(({ theme, specialistOrPractice }) => ({
  ...theme.typography.body2,
  '& .text-highlight': {
    color: theme.palette.primary.main,
    fontWeight: 600
  },
  color: specialistOrPractice ? theme.custom?.SearchBar?.MenuItem.color : theme.palette.text.primary,
  fontWeight: specialistOrPractice ? 600 : 400
}))

export const SearchModalItemContainer = styledComponent(Grid)({
  flex: 1,
  maxWidth: '600px'
})

export const MatchesKeywordsContainer = styledComponent(Box)<HiddenProps>(({ theme }) => ({
  borderBottom: borderStyle,
  display: 'flex',
  padding: '8px 0',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    padding: '8px 16px',
    borderBottom: 'none'
  }
}))

export const SearchModalHeaderTextContainer = styledComponent(Box)({
  borderBottom: borderStyle
})

export const SearchModalHeaderText = styledComponent(Typography)({
  padding: '8px 0 8px 8px'
})

export const SearchModalKeyContainer = styledComponent(Box)({
  padding: '8px 0 8px 8px'
})

export const EmptySearchResultsContainer = styledComponent(Box)({
  width: '100%',
  padding: '32px',
  justifyContent: 'center',
  alignItems: 'center'
})
